import { request, reqintel } from './_request'
import moment from 'moment';
import {Spin,Tooltip,Badge,Rate,Select,Modal,Layout,Menu,Button,Popconfirm,Input,message as messageAntd, Empty} from 'antd';


export const getSeguimientoID = (key , value) => {

    return (dispatch, getState) => {
        const user = JSON.parse(localStorage.getItem('@@auth_user'));
        const idseguimiento = value ; 
        request.get('/garantiainfo/get', { params: {idseguimiento:idseguimiento }, headers: { 'Authorization': `Bearer ${user.token}` } })
            .then((response) => {
                if (response.data.code === 0) {                    
                    dispatch({
                        type: 'SUCCESS_DATA_SEGUIMIENTO', payload: {
                            info: response.data.result.seguimientos
                        }
                    })
                } else {
                    dispatch({ type: 'ERROR_DATA_SEGUIMIENTO', payload: { message: response.data.error } })
                }
            }).catch((e) => {
                console.log(e)
                dispatch({ type: 'ERROR_DATA_SEGUIMIENTO', payload: { message: e.message } })
            })
    }

}


export const saveForm = () => {
    return (dispatch, getState) => {
        const user = JSON.parse(localStorage.getItem('@@auth_user'));

        dispatch({ type: "SAVE_FORM", payload: true })
        let params = getState().saveForm

        const idinterno = params.idos ;
        const comen = params.comentarios;
        const fecha = moment().format('YYYY-MM-DD HH:mm:ss');

        if(comen.length > 0){
            request
            .post('/garantiainfo/save',{idinterno , comen ,fecha }, { headers: {'Authorization':`Bearer ${user.token}`}} )
                .then((response) => {
                    if (response.data.result.code === 0) {
                        messageAntd.info('se ha guardado con exito!');
                        return (dispatch({
                            type: "SAVED_FORM",
                            payload: response.data.result
                        }))

                    } else {
                        messageAntd.danger('Ha ocurrido un error!');
                        return (dispatch({
                            type: "ERROR_SAVED_FORM",
                            payload: response.data.result
                        }))
                    }
                })
        }else{
            messageAntd.warning('Ha ocurrido un error!');
        }
    }

}

export const changevalueForm = (key, value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'CHANGE_VALUE_FORM',
            payload: { [key]: value }
        })
    }
}


export const getApigetPreordenSas = (key , value) => {

    return (dispatch, getState) => {
        const user = JSON.parse(localStorage.getItem('@@auth_user'));
        const idordeninterno = value ; 
        console.log('>id>', idordeninterno)

        request.get('/getapipreordensas/get', { params: {idordeninterno:idordeninterno }, headers: { 'Authorization': `Bearer ${user.token}` } })
            .then((response) => {
                if (response.data.code === 0) {   

                    dispatch({
                        type: 'SUCCESS_DATA_API_PREORDEN', payload: {
                            infoapi: response.data.result
                        }
                    })
                } else {
                    dispatch({ type: 'ERROR_DATA_API_PREORDEN', payload: { message: response.data.error } })
                }
            }).catch((e) => {
                console.log(e)
                dispatch({ type: 'ERROR_DATA_API_PREORDEN', payload: { message: e.message } })
            })
    }

}

export const selectArticulosIntelisis = (val) => {
	return (dispatch) => {
		return new Promise((ready) => {
			reqintel
			.get(`webservice/get_preorden_sas.php?token=jksdjksd&movID=${val}`)
			.then((response) => {
				dispatch({type:'READY_ARTICULOS_INTELISIS',
					payload:response.data
				});
				ready(true)
			})
			.catch((e) => {
				ready(false)
				dispatch({type: 'NO_DATA_INTELISIS_ARTICULOS'});
				}
			);
      })
	};	
};



